(() => {
  if (window.hkPartNumberSearchInitialized) return;
  window.hkPartNumberSearchInitialized = true;
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-hk-part-search]')) return;
    const query = String(event.formData.get('q') || '').trim();
    const number = query.replace(/^#\s*/, '').replace(/\s+/g, '');
    if (/^(?:\d{7,14}|(?:SP|AS)\d{6,10})$/i.test(number)) {
      event.formData.set('q', `variants.sku:"${number.toUpperCase()}"`);
      event.formData.set('type', 'product');
    }
  });
})();
